module.exports = __webpack_public_path__ + "static/media/siddharth-sakleshpur-trip-banner.e604497f.jpg";